const boatTrailers = [
  {
    model: "A TRAILER",
    total_length: "",
    maximum_authorized_mass: "1350 KG",
    axles: "1 X AS 1350 KG",
    cargo_dimensions: "631 X 220 CM",
    own_mass: "",
    loading_capacity: "1020 KG",
    price: 2900,
    newPrice: null,
    img: "images/csonakszallitok/1.jpg",
    imgAlt: "",
  },
  {
    model: "B TRAILER ",
    total_length: "",
    maximum_authorized_mass: "1500 KG",
    axles: "1 X AS 1500 KG",
    cargo_dimensions: "631 X 220 CM",
    own_mass: "",
    loading_capacity: "1160 KG",
    price: 3000,
    newPrice: null,
    img: "images/csonakszallitok/1.jpg",
    imgAlt: "",
  },
  {
    model: "C TRAILER ",
    total_length: "",
    maximum_authorized_mass: "1800 KG",
    axles: "1 X AS 1800 KG",
    cargo_dimensions: "631 X 220 CM",
    own_mass: "",
    loading_capacity: "1400 KG",
    price: 3200,
    newPrice: null,
    img: "images/csonakszallitok/4.jpg",
    imgAlt: "",
  },
  {
    model: "D TRAILER ",
    total_length: "",
    maximum_authorized_mass: "2700 KG",
    axles: "2 X AS 1350 KG",
    cargo_dimensions: "631 X 220 CM",
    own_mass: "",
    loading_capacity: "2220 KG",
    price: 3500,
    newPrice: null,
    img: "images/csonakszallitok/15.jpg",
    imgAlt: "",
  },
  {
    model: "E TRAILER ",
    total_length: "",
    maximum_authorized_mass: "1800 KG",
    axles: "1 X AS 1800 KG",
    cargo_dimensions: "700 X 220 CM",
    own_mass: "",
    loading_capacity: "1370 KG",
    price: 3300,
    newPrice: null,
    img: "images/csonakszallitok/17.jpg",
    imgAlt: "",
  },
  {
    model: "F TRAILER ",
    total_length: "",
    maximum_authorized_mass: "2700 KG",
    axles: "2 X AS 1350 KG",
    cargo_dimensions: "700 X 220 CM",
    own_mass: "",
    loading_capacity: "2190 KG",
    price: 3750,
    newPrice: null,
    img: "images/csonakszallitok/19.jpg",
    imgAlt: "",
  },
  {
    model: "G TRAILER ",
    total_length: "",
    maximum_authorized_mass: "3000 KG",
    axles: "2 X AS 1500 KG",
    cargo_dimensions: "700 X 220 CM",
    own_mass: "",
    loading_capacity: "2450 KG",
    price: 4000,
    newPrice: null,
    img: "images/csonakszallitok/21.jpg",
    imgAlt: "",
  },
  {
    model: "H TRAILER ",
    total_length: "",
    maximum_authorized_mass: "3500 KG",
    axles: "2 X AS 1800 KG",
    cargo_dimensions: "700 X 220 CM",
    own_mass: "",
    loading_capacity: "2920 KG",
    price: 4200,
    newPrice: null,
    img: "images/csonakszallitok/15.jpg",
    imgAlt: "",
  },
  {
    model: "I TRAILER ",
    total_length: "",
    maximum_authorized_mass: "2700 KG",
    axles: "2 X AS 1350 KG",
    cargo_dimensions: "780 X 220 CM",
    own_mass: "",
    loading_capacity: "2140 KG",
    price: 3950,
    newPrice: null,
    img: "images/csonakszallitok/21.jpg",
    imgAlt: "",
  },
  {
    model: "J TRAILER ",
    total_length: "",
    maximum_authorized_mass: "3000 KG",
    axles: "2 X AS 1500 KG",
    cargo_dimensions: "780 X 220 CM",
    own_mass: "",
    loading_capacity: "2400 KG",
    price: 4200,
    newPrice: null,
    img: "images/csonakszallitok/5.jpg",
    imgAlt: "",
  },
  {
    model: "K TRAILER ",
    total_length: "",
    maximum_authorized_mass: "3500 KG",
    axles: "2 X AS 1800 KG",
    cargo_dimensions: "780 X 220 CM",
    own_mass: "",
    loading_capacity: "2880 KG",
    price: 4500,
    newPrice: null,
    img: "images/csonakszallitok/21.jpg",
    imgAlt: "",
  },
  {
    model: "L TRAILER ",
    total_length: "",
    maximum_authorized_mass: "3500 KG",
    axles: "3 X AS 1350 KG",
    cargo_dimensions: "780 X 220 CM",
    own_mass: "",
    loading_capacity: "2840 KG",
    price: 4650,
    newPrice: null,
    img: "images/csonakszallitok/23.jpg",
    imgAlt: "",
  },
  {
    model: "M TRAILER ",
    total_length: "",
    maximum_authorized_mass: "3500 KG",
    axles: "3 X AS 1500 KG",
    cargo_dimensions: "780 X 220 CM",
    own_mass: "",
    loading_capacity: "2800 KG",
    price: 4900,
    newPrice: null,
    img: "images/csonakszallitok/23.jpg",
    imgAlt: "",
  },
  {
    model: "N TRAILER ",
    total_length: "",
    maximum_authorized_mass: "3500 KG",
    axles: "3 X AS 1800 KG",
    cargo_dimensions: "780 X 220 CM",
    own_mass: "",
    loading_capacity: "2760 KG",
    price: 5250,
    newPrice: null,
    img: "images/csonakszallitok/23.jpg",
    imgAlt: "",
  },
  {
    model: "O TRAILER ",
    total_length: "",
    maximum_authorized_mass: "2700 KG",
    axles: "2 X AS 1350 KG",
    cargo_dimensions: "840 X 255 CM",
    own_mass: "",
    loading_capacity: "2130 KG",
    price: 4150,
    newPrice: null,
    img: "images/csonakszallitok/25.jpg",
    imgAlt: "",
  },
  {
    model: "P TRAILER ",
    total_length: "",
    maximum_authorized_mass: "3000 KG",
    axles: "2 X AS 1500 KG",
    cargo_dimensions: "840 X 255 CM",
    own_mass: "",
    loading_capacity: "2390 KG",
    price: 4350,
    newPrice: null,
    img: "images/csonakszallitok/pqtablazat.jpg",
    imgAlt: "",
  },
  {
    model: "Q TRAILER ",
    total_length: "",
    maximum_authorized_mass: "3500 KG",
    axles: "2 X AS 1800 KG",
    cargo_dimensions: "840 X 255 CM",
    own_mass: "",
    loading_capacity: "2860 KG",
    price: 4550,
    newPrice: null,
    img: "images/csonakszallitok/pqtablazat.jpg",
    imgAlt: "",
  },
  {
    model: "R TRAILER ",
    total_length: "",
    maximum_authorized_mass: "3500 KG",
    axles: "3 X AS 1350 KG",
    cargo_dimensions: "840 X 255 CM",
    own_mass: "",
    loading_capacity: "2840 KG",
    price: 4950,
    newPrice: null,
    img: "images/csonakszallitok/23.jpg",
    imgAlt: "",
  },
  {
    model: "S TRAILER ",
    total_length: "",
    maximum_authorized_mass: "3500 KG",
    axles: "3 X AS 1500 KG",
    cargo_dimensions: "840 X 255 CM",
    own_mass: "",
    loading_capacity: "2780 KG",
    price: 5150,
    newPrice: null,
    img: "images/csonakszallitok/23.jpg",
    imgAlt: "",
  },
  {
    model: "T TRAILER ",
    total_length: "",
    maximum_authorized_mass: "3500 KG",
    axles: "3 X AS 1800 KG",
    cargo_dimensions: "840 X 255 CM",
    own_mass: "",
    loading_capacity: "2740 KG",
    price: 5550,
    newPrice: null,
    img: "images/csonakszallitok/23.jpg",
    imgAlt: "",
  },
  {
    model: "U TRAILER ",
    total_length: "",
    maximum_authorized_mass: "3500 KG",
    axles: "2 X AS 1800 KG",
    cargo_dimensions: "920 X 255 CM",
    own_mass: "",
    loading_capacity: "2800 KG",
    price: 4950,
    newPrice: null,
    img: "images/csonakszallitok/5.jpg",
    imgAlt: "",
  },
  {
    model: "V TRAILER ",
    total_length: "",
    maximum_authorized_mass: "3500 KG",
    axles: "3 X AS 1350 KG",
    cargo_dimensions: "920 X 255 CM",
    own_mass: "",
    loading_capacity: "2760 KG",
    price: 5250,
    newPrice: null,
    img: "images/csonakszallitok/23.jpg",
    imgAlt: "",
  },
  {
    model: "W TRAILER ",
    total_length: "",
    maximum_authorized_mass: "3500 KG",
    axles: "3 X AS 1500 KG",
    cargo_dimensions: "920 X 255 CM",
    own_mass: "",
    loading_capacity: "2730 KG",
    price: 5350,
    newPrice: null,
    img: "images/csonakszallitok/23.jpg",
    imgAlt: "",
  },
  {
    model: "X TRAILER ",
    total_length: "",
    maximum_authorized_mass: "3500 KG",
    axles: "3 X AS 1800 KG",
    cargo_dimensions: "920 X 255 CM",
    own_mass: "",
    loading_capacity: "2700 KG",
    price: 5750,
    newPrice: null,
    img: "images/csonakszallitok/23.jpg",
    imgAlt: "",
  },
  {
    model: "Y TRAILER ",
    total_length: "",
    maximum_authorized_mass: "3500 KG",
    axles: "2 X AS 1800 KG",
    cargo_dimensions: "1000 X 255 CM",
    own_mass: "",
    loading_capacity: "2800 KG",
    price: 5150,
    newPrice: null,
    img: "images/csonakszallitok/23.jpg",
    imgAlt: "",
  },
  {
    model: "Z TRAILER ",
    total_length: "",
    maximum_authorized_mass: "3500 KG",
    axles: "3 X AS 1350 KG",
    cargo_dimensions: "1000 X 255 CM",
    own_mass: "",
    loading_capacity: "2750 KG",
    price: 5350,
    newPrice: null,
    img: "images/csonakszallitok/23.jpg",
    imgAlt: "",
  },
  {
    model: "ZA TRAILER ",
    total_length: "",
    maximum_authorized_mass: "3500 KG",
    axles: "3 X AS 1500 KG",
    cargo_dimensions: "1000 X 255 CM",
    own_mass: "",
    loading_capacity: "2700 KG",
    price: 5500,
    newPrice: null,
    img: "images/csonakszallitok/23.jpg",
    imgAlt: "",
  },
  {
    model: "ZB TRAILER ",
    total_length: "",
    maximum_authorized_mass: "3500 KG",
    axles: "3 X AS 1800 KG",
    cargo_dimensions: "1000 X 255 CM",
    own_mass: "",
    loading_capacity: "2670 KG",
    price: 5950,
    newPrice: null,
    img: "images/csonakszallitok/23.jpg",
    imgAlt: "",
  },
];

export default boatTrailers;
